import { render, staticRenderFns } from "./purchaseRecords.vue?vue&type=template&id=bd655c86&scoped=true"
import script from "./purchaseRecords.vue?vue&type=script&lang=js"
export * from "./purchaseRecords.vue?vue&type=script&lang=js"
import style0 from "./purchaseRecords.vue?vue&type=style&index=0&id=bd655c86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd655c86",
  null
  
)

export default component.exports